import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';

import E2eCommsWrapper from '../../atoms/E2eCommsWrapper/E2eCommsWrapper';
import Navbar from '../../molecules/Navbar/Navbar';
import MainContent from '../../molecules/MainContent/MainContent';
import Footer from '../../molecules/Footer/Progressive/Footer';

import './Progressive.scss';

function Progressive() {
  return (
    <div id="pageWrapper">
      <E2eCommsWrapper />
      <Suspense>
        <BrowserRouter>
          <Navbar />
          <MainContent />
          <Footer />
        </BrowserRouter>
      </Suspense>
    </div>
  );
}

export default Progressive;
